import { User } from "data/records";
import { userActions } from "data/resources/users";
import { availableLocales, setMomentLocale } from "lib/localization";

/*
 * NOTE: this file distinguishes between locale and language, but in practice
 * these values should be the same. this was written initially to handle each
 * separately, and i'm keeping the distinction around out of an abundance of
 * caution, and (unlikely) potential usefulness.
 *
 * going forward, we're only persisting language in the users.locale column (another whoopsie)
 */

const selectors = {
  locale: (state) => state.locale, // possibly a IETF locale code, i.e. 'en-US'. region is optional
  language: (state) => state.locale?.slice(0, 2), // IETF language code, i.e. 'en'
};

const types = ["SET_LOCALE"].reduce((a, k) => ({ [k]: `locale/${k}`, ...a }), {});

const localeFromConfig = window.rwgps?.config.locale;
const defaultLocale = availableLocales.includes(localeFromConfig) > 0 ? localeFromConfig : "en";

const reducer = (localeState = defaultLocale, action = {}) => {
  switch (action.type) {
    case types.SET_LOCALE: {
      return action.meta.locale;
    }
    default:
      return localeState;
  }
};

const actions = {
  setLocale: (locale) => (dispatch, getState) => {
    dispatch({
      type: types.SET_LOCALE,
      meta: { locale },
    });
    const userId = getState().currentUser.id;
    if (userId) {
      const params = User.serialize(User({ locale }), ["locale"]);
      dispatch(userActions.update(userId, params));
    }

    setMomentLocale(locale);
  },
};

export { actions as localeActions, types as localeTypes, reducer as localeReducer, selectors as localeSelectors };
